var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfoPrimaryUtilita(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#007BFF",
    d: "M918.984,437.968 C920.808,437.968 922.496,437.512 924.048,436.6 C925.552,435.736 926.736,434.552 927.6,433.048 C928.512,431.496 928.968,429.808 928.968,427.984 C928.968,426.16 928.512,424.472 927.6,422.92 C926.736,421.416 925.552,420.232 924.048,419.368 C922.496,418.456 920.808,418 918.984,418 C917.176,418 915.496,418.456 913.944,419.368 C912.44,420.248 911.248,421.44 910.368,422.944 C909.456,424.496 909,426.176 909,427.984 C909,429.792 909.456,431.472 910.368,433.024 C911.232,434.528 912.416,435.72 913.92,436.6 C915.472,437.512 917.16,437.968 918.984,437.968 Z M919.968,424.984 L918,424.984 L918,422.968 L919.968,422.968 L919.968,424.984 Z M919.968,433 L918,433 L918,427 L919.968,427 L919.968,433 Z",
    transform: "translate(-909 -418)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoPrimaryUtilita);
export default __webpack_public_path__ + "static/media/info-primary-utilita.1690b6d27204f4055a542755c54bad37.svg";
export { ForwardRef as ReactComponent };